/**
 *
 * FiltersByNavigation
 *
 */

import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'components/Common';

import {
  FilterPopover,
  filterPopoverTrigger,
  Checkbox,
  Dropdown,
  Conditional,
  Text,
  List,
} from '@cashfree-intl/coherent';
import {
  CHECKBOX,
  SEARCH,
  DROPDOWN,
  TEXT,
  FILTER_MAPPER,
  CURRENCY_SYMBOL,
} from 'utils/constants'; // eslint-disable-line
import { EXCLUDED_FILTERS } from 'containers/DashboardFilters/constants';
import CustomIcon from '../CustomIcons';
import {
  StyledDropdown,
  StyledSection,
  // StyledInputField,
  // StyledCheckbox,
} from './styled';

import FilterPopoverV2 from './components/FilterPopover';

function FiltersByNavigation({
  onFilterApply,
  handleReset,
  appliedFiltersCount,
  selectedFiltersCount,
  handleFilterChange,
  filtersByNavigation: {
    FILTER_ITEMS = {},
    SEARCH_ITEMS = [],
    hideSearchDropdown = false,
    hideSearchItems = false,
  },
  selectedFilters = {},
  filterContentClassName = '',
  isError,
  regexTest,
  disableCheckbox = false,
  menuSelected,
  buttonDisplayText,
  searchOnly,
  enableSaveFilters = false,
}) {
  const filterItems = Object.keys(FILTER_ITEMS);

  const init = () => (filterItems.length ? filterItems[0] : '');

  const [showFilterList, resetFilterList] = useState(init());
  const [showSubFilterList, resetSubFilterList] = useState('');
  const [searchString, resetSearchString] = useState('');

  const isAdditionalField = key => Object.keys(FILTER_MAPPER).includes(key);

  const handleShowFilterListClick = key => () => {
    resetFilterList(showFilterList === key ? '' : key);
    if (showSubFilterList) resetSubFilterList('');
    if (searchString) resetSearchString('');
  };

  const toggleSubFilterList = key => () => {
    resetSubFilterList(showSubFilterList === key ? '' : key);
    resetSearchString('');
  };

  const renderCheckbox = (items, key, type, args) => {
    const itemsArr = Object.keys(items);
    // eslint-disable-next-line no-unused-vars
    return itemsArr.map((item, index) => {
      if (!item) return null;
      const hasSubFilter = typeof items[item] === 'object';
      let subFilters = null;
      let showIntermediateState = null;
      if (hasSubFilter) {
        subFilters = {
          key: items[item].key,
          type: items[item].type,
          items: items[item].items,
        };
        // do computation for intermediate state
        const lookupArr =
          selectedFilters[items[item].key] || selectedFilters[key];
        if (lookupArr) {
          let count = 0;
          Object.keys(items[item].items).forEach(value => {
            if (lookupArr?.includes(value)) count += 1;
          });
          if (count > 0)
            showIntermediateState =
              count !== Object.keys(items[item].items).length;
        }
      }

      const parentFilter = args || null;

      // const updatedIndex = index + 1;
      // let appendSubFilterList = false;
      // let subArr = itemsArr.slice(index - 2, index + 1);
      // append the list after -
      // 1) every multiple of 3
      // 2) at the end of the iteration if last index is not a multiple of 3
      // if (updatedIndex % 3 === 0) appendSubFilterList = true;
      // else if (updatedIndex === itemsArr.length && updatedIndex % 3 !== 0) {
      //   appendSubFilterList = true;
      //   subArr = itemsArr.slice(index + 1 - (updatedIndex % 3), index + 1);
      // }

      // appendSubFilterList =
      //   appendSubFilterList && subArr.includes(showSubFilterList);

      const appendSubFilterList = itemsArr.includes(showSubFilterList);

      let filteredItems = appendSubFilterList
        ? items[showSubFilterList].items
        : {};

      if (searchString.trim().length > 0) {
        const obj = {};
        Object.keys(filteredItems).forEach(k => {
          if (
            filteredItems[k]
              .trim()
              .toUpperCase()
              .includes(searchString.trim().toUpperCase())
          ) {
            obj[k] = filteredItems[k];
          }
        });
        filteredItems = obj;
      }

      const disableCheckboxLogic = () => {
        if (!disableCheckbox) return false;
        const { respondBy = [] } = selectedFilters;
        if (respondBy.length) {
          if (EXCLUDED_FILTERS[menuSelected].includes(respondBy[0])) {
            return item !== respondBy[0];
          }
          return EXCLUDED_FILTERS[menuSelected].includes(item);
        }
        return false;
      };

      return (
        <React.Fragment key={item}>
          <List.Item
            key={item}
            className={hasSubFilter ? 'sub-filter-item' : ''}
          >
            <List.Content className={hasSubFilter ? 'sub-filter' : ''}>
              <Checkbox
                label={hasSubFilter ? items[item].displayText : items[item]}
                checked={
                  hasSubFilter
                    ? typeof showIntermediateState === 'boolean' &&
                      !showIntermediateState
                    : selectedFilters[key] &&
                      selectedFilters[key].includes(item)
                }
                indeterminate={hasSubFilter && showIntermediateState}
                onChange={handleFilterChange({
                  key,
                  value: item,
                  type,
                  subFilters,
                  parentFilter,
                })}
                disabled={disableCheckboxLogic()}
              />
              {hasSubFilter && (
                // eslint-disable-next-line
                <span
                  className={`sub-filter-cta text-right pointer ${
                    showSubFilterList === item ? 'open' : ''
                  }`}
                  onClick={toggleSubFilterList(item)}
                >
                  <CustomIcon componentName="CHEVRONDOWN" />
                </span>
              )}
            </List.Content>
          </List.Item>
          {showSubFilterList === item && (
            <div className="sub-filter-list full-width ml-3">
              <Input
                className="search-input"
                key="search-string"
                name="search-string"
                value={searchString}
                onChange={e => resetSearchString(e.target.value)}
                fluid
                iconPosition="left"
                icon={<CustomIcon componentName="SEARCH" />}
                placeholder={items[showSubFilterList].placeholder}
              />
              <div className="sub-filter-list-items">
                {renderCheckbox(
                  // items[showSubFilterList].items,
                  filteredItems,
                  items[showSubFilterList].key,
                  items[showSubFilterList].type,
                  {
                    key,
                    value: showSubFilterList,
                    items: items[showSubFilterList].items,
                  }, // parent filter obj
                )}
              </div>
            </div>
          )}
        </React.Fragment>
      );
    });
  };

  const renderDropdown = (items, key, type) => (
    <List.Item className="dropdown-item">
      <List.Content>
        <StyledDropdown>
          <Dropdown
            icon={<CustomIcon componentName="CHEVRONDOWN" />}
            onChange={handleFilterChange({
              key,
              type,
            })}
            options={items}
            placeholder="Choose an option"
            selection
            value={selectedFilters[key]}
          />
        </StyledDropdown>
        {/* special case of dropdown when additional fields needs to be shown depending on the dropdown value selected */}
        {isAdditionalField(key) && selectedFilters[key] && (
          <>
            <div className="order-amount-filter-container mt-3">
              <div className="input-field-container">
                {/* eslint-disable-next-line */}
                <label>Enter {FILTER_MAPPER[key].text}</label>
                <Input
                  label={{
                    basic: true,
                    content: FILTER_MAPPER[key].isRupeeField
                      ? CURRENCY_SYMBOL.INR
                      : '',
                  }}
                  labelPosition="left"
                  onChange={handleFilterChange({
                    key: FILTER_MAPPER[key].start,
                    type: TEXT,
                  })}
                  type="number"
                  value={selectedFilters[FILTER_MAPPER[key].start]}
                />
              </div>
              {selectedFilters[key] === 'IS_BETWEEN' && (
                <>
                  <div className="separator">
                    <span>-</span>
                  </div>
                  <div className="input-field-container">
                    {/* eslint-disable-next-line */}
                    <label>Enter {FILTER_MAPPER[key].text}</label>
                    <Input
                      label={{
                        basic: true,
                        content: FILTER_MAPPER[key].isRupeeField
                          ? CURRENCY_SYMBOL.INR
                          : '',
                      }}
                      labelPosition="left"
                      onChange={handleFilterChange({
                        key: FILTER_MAPPER[key].end,
                        type: TEXT,
                      })}
                      type="number"
                      value={selectedFilters[FILTER_MAPPER[key].end]}
                    />
                  </div>
                </>
              )}
            </div>
            {isError && (
              <span className="error-order-amount">
                {/* eslint-disable-next-line */}
                ‘FROM' {FILTER_MAPPER[key].text} cannot be greater than 'TO’{' '}
                {FILTER_MAPPER[key].text}
              </span>
            )}
          </>
        )}
      </List.Content>
    </List.Item>
  );

  // render filter elements based on filter type

  const renderFilterElements = (filterObj, key) => {
    const { type, items } = filterObj;
    if (type === CHECKBOX && items) {
      return renderCheckbox(items, key, type);
    }
    if (type === DROPDOWN) {
      return renderDropdown(items, key, type);
    }
    return null;
  };

  // calling this function for clearing the text input

  const handleCloseIconClick = e =>
    handleFilterChange({
      key: TEXT,
      type: SEARCH,
    })(e, { value: '' });

  const renderSearchInput = (searchItems, onApply) => {
    let dropdownValue = searchItems[0].value;
    let placeholder = searchItems[0].placeholder || `Enter ${dropdownValue}`;

    let inputValue = '';
    let inputType;
    let inputMaxLength;
    let errorMessage;

    if (selectedFilters[SEARCH]) {
      inputValue = selectedFilters[SEARCH].value;
      dropdownValue = selectedFilters[SEARCH].type;

      searchItems.forEach(item => {
        if (item.value === dropdownValue) {
          errorMessage = item.error ? item.error : '';
          inputMaxLength = item.maxLength ? item.maxLength : null;
          inputType = item.inputType ? item.inputType : 'text';
          placeholder = item.placeholder
            ? item.placeholder
            : `Enter ${dropdownValue}`;
        }
      });
    }
    const onKeyDown = e => {
      if (e.key === 'Enter') {
        onApply();
      } else if (
        inputType === 'number' &&
        ['e', 'E', '+', '-'].includes(e.key)
      ) {
        e.preventDefault();
      }
    };
    return (
      <>
        <Input
          label={
            hideSearchDropdown ? null : (
              <Dropdown
                options={searchItems}
                icon={<CustomIcon componentName="CHEVRONDOWN" />}
                className="primary-dropdown"
                onChange={handleFilterChange({
                  key: DROPDOWN,
                  type: SEARCH,
                })}
                value={dropdownValue}
              />
            )
          }
          className="search-input-with-dropdown"
          fluid
          labelPosition="left"
          placeholder={placeholder}
          value={inputValue}
          onKeyDown={onKeyDown}
          type={inputType}
          maxLength={inputMaxLength}
          onChange={handleFilterChange({
            key: dropdownValue,
            type: SEARCH,
          })}
          icon={
            <div className="close-icon">
              {/* eslint-disable-next-line */}
              <span
                className={`${!inputValue ? 'visibility-hidden' : ''}`}
                onClick={handleCloseIconClick}
              >
                <CustomIcon componentName="CLOSE" fill="#434343" />
              </span>
            </div>
          }
        />
        {!regexTest && (
          <span className="error-search-item">{errorMessage}</span>
        )}
      </>
    );
  };

  const renderSearchItems = (searchItems, onApply) => (
    <div className="filter-search-container">
      <div className="filter-category text-dark normal-text w-600">Search</div>
      {!searchItems || searchItems.length === 0 ? (
        <div className="w-600 text-light small-text">No search available</div>
      ) : (
        renderSearchInput(searchItems, onApply)
      )}
    </div>
  );

  const FilterPopoverComponent = enableSaveFilters
    ? FilterPopoverV2
    : FilterPopover;

  let savedFilterNames = [];
  if (enableSaveFilters && FILTER_ITEMS.saved?.items?.length > 0) {
    savedFilterNames = FILTER_ITEMS.saved.items.map(obj => obj.text);
  }

  let applyButtonText = '';
  let saveFilterGroupError = '';
  if (
    selectedFiltersCount > 0 &&
    Object.keys(selectedFilters).includes('saved')
  ) {
    applyButtonText = 'Apply Saved Filter';
    saveFilterGroupError =
      'Selected filters already saved. No changes were made.';
  }

  return (
    <FilterPopoverComponent
      value={{}}
      onApply={(data, groupName) => {
        onFilterApply(groupName);
      }}
      trigger={filterPopoverTrigger}
      onClear={handleReset}
      appliedFiltersCount={appliedFiltersCount}
      selectedFiltersCount={selectedFiltersCount}
      buttonDisplayText={buttonDisplayText}
      savedFilterNames={savedFilterNames}
      applyButtonText={applyButtonText}
      errorMessage={saveFilterGroupError}
    >
      {(filterData, onFilterChange, onApply) => (
        <div className={enableSaveFilters ? 'mt-4' : ''}>
          {/* Add the condition that at least selectedFiltersCount is more than 0  */}
          <div className={`filter-content ${filterContentClassName}`}>
            {/* Search Items */}
            {hideSearchItems ? null : renderSearchItems(SEARCH_ITEMS, onApply)}
            {/* Filter Items */}
            <Conditional if={!searchOnly}>
              <div className="filter-category text-dark normal-text w-600 filter-heading">
                Filters
                {filterItems && filterItems.length === 0 && (
                  <div className="filter-not-available w-600 text-light small-text">
                    No filters available
                  </div>
                )}
              </div>
            </Conditional>
            <StyledSection>
              {filterItems.map((key, index) => {
                const obj = FILTER_ITEMS[key];
                return (
                  <div className="filter-list-item" key={key}>
                    {/* eslint-disable-next-line */}
                <div
                      className={`filter-subheader ${
                        showFilterList === key ? 'highlight' : ''
                      }`}
                      onClick={handleShowFilterListClick(key)}
                    >
                      <div className="medium-text">{obj.displayText}</div>
                      <CustomIcon
                        componentName="CHEVRONDOWN"
                        direction={showFilterList === key ? 'up' : 'down'}
                      />
                    </div>
                    {showFilterList === key && (
                      <>
                        <Conditional if={obj.remark}>
                          <Text
                            className="filter-remark"
                            variant="b12"
                            color="bodyLight"
                          >
                            {obj.remark}
                          </Text>
                        </Conditional>
                        <List relaxed className="filter-list">
                          {renderFilterElements(obj, key)}
                        </List>
                      </>
                    )}
                    {index + 1 !== filterItems.length && (
                      <div className="divider" />
                    )}
                  </div>
                );
              })}
              {/* <Conditional
                if={
                  enableSaveFilters &&
                  selectedFiltersCount > 0 &&
                  !Object.keys(selectedFilters).includes('saved')
                }
              >
                <div
                  className={`ml-4 ${
                    showFilterList === 'orderAmount' ? '' : 'mt-2'
                  }`}
                >
                  <StyledCheckbox
                    label="Save selected filter group for future"
                    checked={showSaveFilterInput}
                    onChange={(e, data) => {
                      resetSaveFilterInput(data.checked);
                      resetFilterList('');
                      resetSubFilterList('');
                    }}
                  />
                  <Conditional if={showSaveFilterInput}>
                    <>
                      <Text className="mb-1" color="bodyLight">
                        Group Name
                      </Text>
                      <StyledInputField
                        className="m-0 mb-1"
                        fluid
                        id="note"
                        name="note"
                        value={filterName}
                        placeholder=""
                        onChange={e => setFilterName(e.target.value)}
                      />
                    </>
                  </Conditional>
                </div>
              </Conditional> */}
            </StyledSection>
          </div>
        </div>
      )}
    </FilterPopoverComponent>
  );
}

FiltersByNavigation.propTypes = {
  onFilterApply: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  appliedFiltersCount: PropTypes.number,
  selectedFiltersCount: PropTypes.number,
  filtersByNavigation: PropTypes.object,
  selectedFilters: PropTypes.object,
  filterContentClassName: PropTypes.string,
  isError: PropTypes.bool,
  regexTest: PropTypes.bool,
  disableCheckbox: PropTypes.bool,
  menuSelected: PropTypes.string,
  buttonDisplayText: PropTypes.string,
  searchOnly: PropTypes.bool,
  enableSaveFilters: PropTypes.bool,
};

export default memo(FiltersByNavigation);
